import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const SWATCHES = [
  '#0F172A',
  '#334155',
  '#2563EB',
  '#7C3AED',
  '#DB2777',
  '#EF4444',
  '#F97316',
  '#EAB308',
  '#16A34A',
  '#14B8A6',
  '#06B6D4',
  '#F8FAFC',
];

const ColorPicker = ({ label, color, onChange }) => {
  const [hex, setHex] = useState(color.replace('#', '').toUpperCase());
  useEffect(() => setHex(color.replace('#', '').toUpperCase()), [color]);
  const updateHex = (value) => {
    const clean = value
      .trim()
      .replace(/^#/, '')
      .replace(/[^0-9a-f]/gi, '')
      .slice(0, 6)
      .toUpperCase();
    setHex(clean);
    if (clean.length === 6) onChange(`#${clean}`);
  };
  return (
    <div className="color-picker">
      <div className="field-label">
        <span>{label}</span>
        <span className="color-dot" style={{ backgroundColor: color }} />
      </div>
      <div className="swatch-grid" aria-label={`${label} colour swatches`}>
        {SWATCHES.map((swatch) => (
          <button
            key={swatch}
            type="button"
            className={`swatch ${color.toLowerCase() === swatch.toLowerCase() ? 'selected' : ''}`}
            style={{ backgroundColor: swatch }}
            onClick={() => onChange(swatch)}
            aria-label={`Use ${swatch}`}
          />
        ))}
      </div>
      <div className="picker-row">
        <input
          className="native-color-input"
          type="color"
          value={/^#[0-9a-f]{6}$/i.test(color) ? color : '#000000'}
          onChange={(e) => {
            setHex(e.target.value.slice(1).toUpperCase());
            onChange(e.target.value.toUpperCase());
          }}
          aria-label={`${label} visual color picker`}
        />
        <div className="hex-field">
          <input
            aria-label={`${label} hex value`}
            value={`#${hex}`}
            maxLength="7"
            onChange={(e) => updateHex(e.target.value)}
            onBlur={() => {
              if (hex.length === 6) onChange(`#${hex}`);
              if (hex.length === 3)
                onChange(
                  `#${hex
                    .split('')
                    .map((char) => char + char)
                    .join('')}`,
                );
            }}
          />
        </div>
      </div>
    </div>
  );
};

ColorPicker.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default ColorPicker;
